import { motion } from "framer-motion";
import { METRICS } from "@/data/content";

export const Metrics = () => {
  return (
    <section id="metrics" data-testid="metrics-section" className="bg-[#FAFAFA] border-b border-[#E5E5E5]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 border-l border-[#E5E5E5]">
          {METRICS.map((m, i) => (
            <motion.div
              key={m.label}
              data-testid={`metric-${i}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className="border-r border-t border-b border-[#E5E5E5] px-8 py-12 md:py-16"
            >
              <div className="font-display font-black text-5xl md:text-6xl tracking-tighter text-[#002DFF]">
                {m.value}
              </div>
              <div className="mt-3 text-xs font-bold uppercase tracking-[0.2em] text-[#525252]">
                {m.label}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
